import { Injectable } from '@angular/core';
import { AlarisProfileService, RouterDataLinks } from '@campaign-portal/components-library';

import { OwnerService } from './owner.service';
import { AP_PERMISSIONS } from '../types';
import { routerLinks } from '../constants';

@Injectable({ providedIn: 'root' })
export class MenuService {
	readonly menuList: RouterDataLinks;

	constructor(
		private readonly ownerService: OwnerService,
		private readonly profile: AlarisProfileService
	) {
		this.menuList = this.buildMenu();
	}

	private buildMenu(): RouterDataLinks {
		const menu: RouterDataLinks = { ...routerLinks };

		if (!this.ownerService.is) {
			menu.settings = {
				...menu.settings,
				children: menu.settings.children?.filter((r) => r.path !== 'mccmnc'),
			};
		}

		if (!(this.ownerService.is || this.profile.allowed([AP_PERMISSIONS.V_SUBSCR_R]))) {
			delete menu.rates;
		}

		return menu;
	}
}
